<template>
  <div id="func-53-local">
    <span class="title padding-title">{{ titulo }}</span>

    <el-card
      v-show="alertaPrincipal"
      :style="`border: 1px solid ${corSecundaria};
    background-color:${corSecundariaAlpha}`"
      class="warning alerta"
      shadow="never">
      <el-row>
        <el-col :span="22">
              <span :style="'color:' + corSecundaria " class="text-color-small">
               {{ alertaPrincipal }}</span>
        </el-col>
        <el-col :span="2">
          <el-button class="btn-close" type="text" @click="removeAlertaPrincipal(alertaPrincipal)">
            <inline-svg :fill="corSecundaria" :src="require('@/assets/icons/Icon_box_close.svg')" class="float-right"
                        height="16"/>
          </el-button>
        </el-col>
      </el-row>
    </el-card>

    <el-card
      :style="`background-color:${corPrimariaAlpha}`"
      class="card-lista"
      shadow="never"
    >
      <div v-if="exibeCardLocalIndefinido"
        style="cursor: pointer"
        @click="nextStep({})"
      >
        <el-row>
          <el-col :span="22" class="card-content">
            <div class="endereco">
              <span class="text-bold-small break">{{ tituloCardLocalIndefinido }}</span>
              <span class="text-regular-small">{{ descricaoCardLocalIndefinido }}</span>
            </div>
          </el-col>
          <el-col :span="2">
            <div style="position: absolute; height: 100%;">
              <el-button class="float-right align-btn" type="text" @click="nextStep({})">
                <span class="text-btn"/>
                <inline-svg :fill="corPrimaria" :src="require('@/assets/icons/Arrow_chevron.svg')"
                            class="arrow"/>
              </el-button>
            </div>
          </el-col>
        </el-row>
      </div>
    </el-card>

    <el-card
      v-for="(item, i) in listaLocal" :key="i"
      :style="`background-color:${corPrimariaAlpha}`"
      class="card-lista"
      shadow="never"
    >
      <div style="cursor: pointer" @click="nextStep(item)">
        <el-row>
          <el-col :span="22" class="card-content">
            <div class="endereco">
              <span class="text-bold-small break">{{ item.descricao }}</span>
              <span class="text-regular-small">{{ endereco(item.endereco) }}</span>
              <el-button :style="`color: ${corPrimaria}`" class="btn-azul" type="text break">CONTATOS</el-button>
            </div>
          </el-col>
          <el-col :span="2">
            <div style="position: absolute; height: 100%;">
              <el-button class="float-right align-btn" type="text" @click="nextStep(item)">
                <span class="text-btn"/>
                <inline-svg :fill="corPrimaria" :src="require('@/assets/icons/Arrow_chevron.svg')"
                            class="arrow"/>
              </el-button>
            </div>
          </el-col>
        </el-row>
      </div>
      <div class="pop-up">
        <el-card v-show="item.alerta"
                 :style="`border: 1px solid ${corSecundaria};
                border: 1px solid ${corSecundaria};
                box-shadow: none;
                background-color: #FFFFFF`"
                 class="warning" shadow="never">
          <div style="display: flex; justify-content: space-between">
                      <span :style="'color:' + corSecundaria " class="text-color-small">
                       {{ item.alerta }}</span>
            <el-button class="btn-close" type="text" @click="removeAlerta(item)">
              <inline-svg :fill="corSecundaria" :src="require('@/assets/icons/Icon_box_close.svg')" class="float-right"
                          height="16"/>
            </el-button>
          </div>
        </el-card>
      </div>
    </el-card>
  </div>
</template>
<script>
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex'
import inlineSvg from 'vue-inline-svg'

export default {
  data () {
    return {
      alertaPrincipal: ''
    }
  },
  computed: {
    ...mapState('SetupApp', ['apiFuncionalidade', 'funcionalidade']),
    ...mapGetters('SetupApp', ['estilo']),
    ...mapState('Func53', ['idEspecialidade', 'paciente', 'idAgenda', 'idServico', 'listaLocal']),
    corPrimariaAlpha () {
      return `${this.estilo.aplicacao.corPrimariaAplicacao}1A`
    },
    corPrimaria () {
      return `${this.estilo.aplicacao.corPrimariaAplicacao}`
    },
    corSecundaria () {
      return `${this.estilo.aplicacao.corSecundariaAplicacao}`
    },
    corSecundariaAlpha () {
      return `${this.estilo.aplicacao.corSecundariaAplicacao}1A`
    },
    ordem () {
      return this.funcionalidade.parametros.ordemLocalEspecialidades
    },
    titulo () {
      return this.funcionalidade.parametros.textos.tituloTelaSelecionarLocalAtendimento
    },
    exibeCardLocalIndefinido () {
      return this.funcionalidade.parametros.exibeCardLocalIndefinido
    },
    tituloCardLocalIndefinido () {
      return this.funcionalidade.parametros.textos.tituloCardLocalIndefinido
    },
    descricaoCardLocalIndefinido () {
      return this.funcionalidade.parametros.textos.descricaoCardLocalIndefinido
    }
  },
  methods: {
    ...mapActions('Func53', ['setIdLocal', 'setLocalAtendimento']),
    ...mapMutations('Func53', ['SET_LISTA_LOCAL']),
    ...mapActions('BreadCrumbsStore', ['updateIten']),
    ...mapMutations('BreadCrumbsStore', ['SET_CURRENT_STEP']),
    async init () {
      const payload = {
        paciente: this.paciente,
        idEspecialidade: this.idEspecialidade,
        tipoAgenda: this.idAgenda
      }
      if (this.idServico) {
        payload.idServico = this.idServico
      }
      const res = await this.apiFuncionalidade.listaLocaisAtendimento({
        payload,
        loading: true
      })
      this.SET_LISTA_LOCAL(res.data.locais)
      this.alertaPrincipal = res.data.alertaPrincipal
    },
    endereco (value) {
      return `${value.endereco}, ${value.numero}, ${value.bairro}, ${value.cidade} - ${value.estado}`
    },
    nextStep (item) {
      let value
      this.setIdLocal(item.id)
      this.setLocalAtendimento(item)

      let step
      this.ordem === 2 ? step = 2 : step = 3
      const payload = { step: step, value: item.descricao }
      this.updateIten(payload)

      this.$route.query.step === '3' ? value = 4 : value = 5
      this.$router.replace({ query: { step: value } })
    },
    async removeAlerta (item) {
      const i = this.listaLocal.findIndex(el => el.id === item.id)
      this.$set(this.listaLocal[i], 'alerta', false)
    },
    removeAlertaPrincipal () {
      this.alertaPrincipal = ''
    }
  },
  components: { inlineSvg },
  async created () {
    this.SET_CURRENT_STEP(3)
    await this.init()
  }
}
</script>
<style lang="less">
#func-53-local {
  padding: 0 20px 0 20px;

  .card-lista {
    border: unset;
    border-radius: 6px;
    box-shadow: none;
  }

  .el-card {
    margin-bottom: 10px;
  }

  .card-lista:nth-child(3) {
    margin-top: 20px;
  }

  .break {
    display: block;
    margin-bottom: 5px;
  }

  .text-bold-small {
    font-size: 14px;
    text-align: left;
    color: #333333;
    font-weight: 600;
  }

  .text-regular-small {
    font-size: 12px;
    color: #333333;
    line-height: 17px;
    text-align: left;
  }

  .text-color-small {
    font-size: 10px;
    line-height: 17px;
    text-align: left;
    width: 414px;
  }

  .float-right {
    float: right;
  }

  .align-btn {
    position: relative;
    height: inherit;
  }

  .text-btn {
    text-transform: lowercase;
    font-weight: 400;
    color: #333333;
    font-size: 12px;
    position: relative;
    bottom: 4px;
    right: 4px;

  }

  .btn-azul {
    padding: 0;
    margin-top: 10px;
    font-family: "Open Sans", sans-serif;
  }

  .warning {
    background-color: #FFFFFF;
    border-color: 1px solid var(--cor-secundaria);
    border-radius: 6px;
    margin-top: 10px;
    margin-bottom: 0;
    box-shadow: none;
  }

  .alerta {
    margin-top: 20px;
  }

  .title {
    font-size: 20px;
    font-family: "Open Sans", SansSerif;
    text-align: left;
    line-height: 27px;
    font-weight: 600;
    color: #333333;
    padding-top: 30px;
    display: block;
  }

  .btn-close {
    padding: 0;
    float: right;
    position: relative;
    left: 10px;
  }

  .reset {
    background: none;
    border: none;
    margin: 0;
    padding: 0;
    border: 0;
    font-size: 100%;
    font: inherit;
    text-transform: none;
  }
}
</style>
